export default __webpack_public_path__ + "static/media/download.7ac1b4cc.gif";